import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css']
})
export class PageHeaderComponent implements OnInit {

  @Input() titulo: string;
  @Input() icono: string;
  @Input() breadcrumbs: any[];


  constructor() { }

  ngOnInit(): void {
  }

}
